import { API_ENDPOINT } from './config';

export const urlsContent = {
  news: (categories, page, isEnglish) => {
    if (categories != null || page != null) {
      const categoriesParams = `${categories.map((categoryId) => `categories[]=${categoryId}&`).join('')}`;
      return `${API_ENDPOINT}/news?${categoriesParams}&page=${page}&english=${isEnglish}`;
    }
    return `${API_ENDPOINT}/news`;
  },
  newsNormal: `${API_ENDPOINT}/news`,
  newsEdit: `${API_ENDPOINT}/news?edit=true`,
  newsArchive: (english = false) =>
    english
      ? `${API_ENDPOINT}/news?archive=true&english=true`
      : `${API_ENDPOINT}/news?archive=true`,
  newsDetail: (slug, isEdit) =>
    isEdit
      ? `${API_ENDPOINT}/news/${slug}?edit=true`
      : `${API_ENDPOINT}/news/${slug}`,
  newsCategory: (categoryId) => `${API_ENDPOINT}/news-categories/${categoryId}`,
  newsCategories: `${API_ENDPOINT}/news-categories`,
  presentationImages: `${API_ENDPOINT}/upload/presentation-images`,

  // Blocks
  blocks: `${API_ENDPOINT}/blocks`,
  blocksEdit: `${API_ENDPOINT}/blocks?edit=true`,
  blockDetail: (id) => `${API_ENDPOINT}/blocks/${id}`,
  blocksOrder: `${API_ENDPOINT}/blocks/order`,

  // Useful links
  links: (english = false) =>
    english
      ? `${API_ENDPOINT}/useful-links?english=true`
      : `${API_ENDPOINT}/useful-links`,
  linkDetail: (slug) => `${API_ENDPOINT}/useful-links/${slug}`,

  // Faculty statistics (homepage counter)
  facultyStatistics: `${API_ENDPOINT}/faculty-statistics`,

  // Menu
  menu: `${API_ENDPOINT}/menu`,
  menuTree: (english = false) =>
    english
      ? `${API_ENDPOINT}/menu?tree=true&english=true`
      : `${API_ENDPOINT}/menu?tree=true`,
  menuDetail: (id) => `${API_ENDPOINT}/menu/${id}`,
  menuOrder: `${API_ENDPOINT}/menu/order`,

  // Articles
  articlesDetail: (slug, isEdit) =>
    isEdit
      ? `${API_ENDPOINT}/articles/${slug}?edit=true`
      : `${API_ENDPOINT}/articles/${slug}`,
  articles: `${API_ENDPOINT}/articles`,

  // Sliders
  sliders: `${API_ENDPOINT}/sliders`,
  slidersEdit: `${API_ENDPOINT}/sliders?edit=true`,
  sliderDetail: (slug) => `${API_ENDPOINT}/sliders/${slug}`,
  sliderOrder: `${API_ENDPOINT}/sliders/order`,
};

export const routesContent = {
  // Public
  homePage: '/',
  article: '/stranka',
  articleEnglish: '/page',
  newsDetail: '/aktualita',
  newsDetail2: '/aktuality',
  newsDetailEnglish: '/news',
  newsArchive: '/archiv-aktualit',
  studyPlans: '/studijne-plany',
  department: '/pracoviska',
  departmentEnglish: '/department',

  // CMS

  // News
  cmsNews: '/cms/news',
  cmsNewsCreate: '/cms/news/create',
  cmsNewsEdit: '/cms/news/edit',
  cmsNewsCategories: '/cms/news-categories',
  cmsNewsCategoriesCreate: '/cms/news-categories/create',
  cmsNewsCategoriesEdit: '/cms/news-categories/edit',

  // Articles
  cmsArticles: '/cms/articles',
  cmsArticleEdit: '/cms/articles/edit',
  cmsArticleCreate: '/cms/articles/create',

  // Banners
  cmsSliders: '/cms/banners',
  cmsSliderEdit: '/cms/banners/edit',
  cmsSliderCreate: '/cms/banners/create',
  cmsSliderOrder: '/cms/banners/order',

  // Blocks
  cmsBlocks: '/cms/blocks',
  cmsBlocksEdit: '/cms/blocks/edit',
  cmsBlocksCreate: '/cms/blocks/create',
  cmsBlocksOrder: '/cms/blocks/order',

  // WIKI pages
  cmsWikiPageCreate: '/cms/wiki-pages/create',
  cmsWikiPagePreview: '/cms/wiki-pages/preview',
  cmsWikiPageEdit: '/cms/wiki-pages/edit',

  // Useful links
  cmsUsefulLinks: '/cms/useful-links',
  cmsUsefulLinksEdit: '/cms/useful-links/edit',
  cmsUsefulLinksCreate: '/cms/useful-links/create',

  // Menu
  cmsMenu: '/cms/menu',
  cmsMenuCreate: '/cms/menu/create',
  cmsMenuEdit: '/cms/menu/edit',
  cmsMenuOrder: '/cms/menu/order',
};
